import { render, staticRenderFns } from "./CurriculumMenuTItem.vue?vue&type=template&id=4dce4130&scoped=true&"
import script from "./CurriculumMenuTItem.vue?vue&type=script&lang=ts&"
export * from "./CurriculumMenuTItem.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumMenuTItem.vue?vue&type=style&index=0&id=4dce4130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce4130",
  null
  
)

export default component.exports